import { createUseStyles } from 'react-jss';

type BypassStyleNames = 'skipLinks';
type BypassStyleProps = { isFocused: boolean };
const useStyles = createUseStyles<BypassStyleNames, BypassStyleProps>({
  skipLinks: ({ isFocused }) => ({
    position: isFocused ? 'fixed' : 'absolute',
    clip: isFocused ? 'auto' : 'rect(0 0 0 0)',
    width: isFocused ? '100%' : '1px',
    height: isFocused ? 'auto' : '1px',
    padding: isFocused ? [10] : [0],
    top: 0,
    left: 0,
    zIndex: 999999,
    overflow: 'hidden',

    backgroundColor: '#fff',

    // add spacing between multiple skip links
    '& > a': {
      marginRight: '8px',
    },
  }),
});

export default useStyles;
